import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'About', href: 'about' },
  { label: 'Cities', href: 'cities' },
  { label: 'Speakers', href: 'speakers' },
  { label: 'Prayer Wall', href: 'prayer' },
  { label: 'Volunteer', href: 'get-involved' },
  { label: 'Media', href: 'media' },
  { label: 'Merch', href: 'merch' },
  { label: 'FAQ', href: 'faq' },
];

const S = {
  nav: (scrolled, open) => ({
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
    padding: scrolled ? '14px 48px' : '24px 48px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    background: scrolled || open ? 'rgba(8,8,8,0.95)' : 'transparent',
    backdropFilter: scrolled || open ? 'blur(12px)' : 'none',
    borderBottom: scrolled ? '1px solid rgba(200,68,10,0.15)' : '1px solid transparent',
    transition: 'all 0.4s ease',
  }),
  logo: { fontFamily: 'var(--font-display)', fontSize: 28, letterSpacing: '0.15em', color: 'var(--white)', textDecoration: 'none' },
  links: (open) => ({
    display: 'flex', gap: 32, listStyle: 'none', alignItems: 'center',
    '@media(max-width:768px)': { display: open ? 'flex' : 'none' },
  }),
  link: { fontFamily: 'var(--font-body)', fontSize: 11, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(245,240,232,0.6)', textDecoration: 'none' },
  cta: { background: 'var(--ember)', color: 'var(--white)', padding: '10px 24px', fontFamily: 'var(--font-body)', fontSize: 11, fontWeight: 500, letterSpacing: '0.18em', textTransform: 'uppercase', textDecoration: 'none', border: 'none', display: 'inline-block' },
  hamburger: { display: 'none', background: 'none', border: 'none', flexDirection: 'column', gap: 5, padding: 4 },
};

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
}

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav style={S.nav(scrolled, open)}>
      <a href="/" style={S.logo}>
        REVIVE<span style={{ color: 'var(--ember)' }}>.</span>
      </a>

      {/* Desktop links */}
      <ul style={{ display: 'flex', gap: 32, listStyle: 'none', alignItems: 'center' }}
        className="nav-desktop-links">
        {navLinks.map(l => (
          <li key={l.href}>
            <button
              onClick={() => scrollTo(l.href)}
              style={{
                ...S.link,
                background: 'none', border: 'none',
                color: hovered === l.href ? 'var(--white)' : 'rgba(245,240,232,0.6)',
                transition: 'color 0.3s',
              }}
              onMouseEnter={() => setHovered(l.href)}
              onMouseLeave={() => setHovered(null)}
            >{l.label}</button>
          </li>
        ))}
        <li>
          <button onClick={() => scrollTo('register')} style={S.cta}
            onMouseEnter={e => e.target.style.background = 'var(--ember-light)'}
            onMouseLeave={e => e.target.style.background = 'var(--ember)'}>
            Register Now
          </button>
        </li>
      </ul>

      {/* Mobile hamburger */}
      <button
        onClick={() => setOpen(!open)}
        style={{ display: 'none', background: 'none', border: 'none', flexDirection: 'column', gap: 5, padding: 4 }}
        className="nav-hamburger"
        aria-label="Menu">
        {[0,1,2].map(i => (
          <span key={i} style={{ display: 'block', width: 24, height: 1, background: 'var(--white)', transition: 'all 0.3s' }} />
        ))}
      </button>

      {/* Mobile menu */}
      {open && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(8,8,8,0.98)', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: 32, zIndex: 99,
        }}>
          <button onClick={() => setOpen(false)} style={{ position: 'absolute', top: 24, right: 24, background: 'none', border: 'none', color: 'var(--white)', fontSize: 28 }}>✕</button>
          {navLinks.map(l => (
            <button key={l.href} onClick={() => { scrollTo(l.href); setOpen(false); }}
              style={{ fontFamily: 'var(--font-display)', fontSize: 36, letterSpacing: '0.1em', color: 'var(--white)', background: 'none', border: 'none' }}>
              {l.label}
            </button>
          ))}
          <button onClick={() => { scrollTo('register'); setOpen(false); }}
            style={{ ...S.cta, fontSize: 14, padding: '14px 40px', marginTop: 16 }}>
            Register Now
          </button>
        </div>
      )}

      <style>{`
        @media (max-width: 900px) {
          .nav-desktop-links { display: none !important; }
          .nav-hamburger { display: flex !important; }
        }
      `}</style>
    </nav>
  );
}
